// Filament Finder: wizard ghidat + motor de scor centralizat (sectiunea 15 din brief).
// Toate datele (produse/variante/metafields) vin din #td-finder-data (randat de
// snippets/filament-finder.liquid din product.metafields.custom.* si optiunile reale
// Culoare/Ambalare) si din window.TD_FILAMENT_MATERIALS (randat in filament-finder.liquid
// din metaobject-ul "Filament Material", administrabil din Shopify Admin).
// Nicio recomandare nu se bazeaza pe cuvinte din titlul produsului.
(function () {
  const root = document.getElementById('filament-finder');
  if (!root) return;

  const dataEl = document.getElementById('td-finder-data');
  let PRODUCTS = [];
  try { PRODUCTS = JSON.parse(dataEl.textContent || '[]'); } catch (e) { PRODUCTS = []; }

  const MATERIALS = window.TD_FILAMENT_MATERIALS || {};
  const MAX_RESULTS = parseInt(root.dataset.maxResults, 10) || 3;
  const SHOW_DIFFICULTY = root.dataset.showDifficulty === 'true';
  const SHOW_WARNINGS = root.dataset.showWarnings === 'true';

  const APPLICATIONS = [
    { slug: 'decorative', label: 'Printuri simple și decorative', note: 'Decorațiuni, figurine, prototipuri vizuale, piese pentru uz general' },
    { slug: 'functional', label: 'Piese funcționale', note: 'Suporturi, carcase, mecanisme, scule și accesorii' },
    { slug: 'outdoor', label: 'Utilizare la exterior', note: 'Piese expuse la soare, ploaie, carcase outdoor' },
    { slug: 'heat', label: 'Temperatură ridicată', note: 'Piese lângă surse de căldură, componente auto' },
    { slug: 'flexible', label: 'Flexibilitate', note: 'Garnituri, protecții, tălpi, bumpere' },
    { slug: 'impact', label: 'Rezistență mecanică și impact', note: 'Cleme, balamale, angrenaje, piese solicitate' },
    { slug: 'speed', label: 'Viteză mare de printare', note: 'Loturi mari, prototipare rapidă' },
    { slug: 'finish', label: 'Finisaj vizual premium', note: 'Mat, lucios, silk, texturat, transparent' },
  ];

  const CONDITIONS = [
    { key: 'outdoor', label: 'Piesa va fi folosită la exterior?' },
    { key: 'heat', label: 'Va fi expusă la temperaturi ridicate?' },
    { key: 'flexible', label: 'Trebuie să fie flexibilă?' },
    { key: 'impact', label: 'Trebuie să reziste la impact?' },
    { key: 'visual', label: 'Aspectul vizual este prioritar?' },
    { key: 'enclosure', label: 'Ai imprimantă închisă?' },
    { key: 'ams', label: 'Ai sistem AMS?' },
    { key: 'drying', label: 'Poți usca filamentul înainte de printare?' },
  ];

  const STEPS = ['experience', 'application', 'conditions', 'results', 'colors', 'packaging', 'final'];

  let state = {
    experience: null,
    application: null,
    conditions: {},
    stepIndex: 0,
    results: [],
    chosenMaterialKey: null,
    chosenProduct: null,
    chosenColor: null,
    chosenPackaging: null,
  };

  function resetState() {
    state = { experience: null, application: null, conditions: {}, stepIndex: 0, results: [], chosenMaterialKey: null, chosenProduct: null, chosenColor: null, chosenPackaging: null };
  }

  // ---------- motor de scor (sectiunea 15) ----------
  function scoreMaterial(materialKey, material) {
    let score = 0;
    const apps = material.applications || [];
    if (state.application && apps.includes(state.application)) score += 5;

    const diff = material.difficulty;
    if (state.experience === 'beginner') {
      if (diff === 'Incepator') score += 3;
      else if (diff === 'Avansat') score -= 2;
    } else if (state.experience === 'some') {
      if (diff === 'Intermediar') score += 3;
      else score += 1;
    } else if (state.experience === 'advanced' || state.experience === 'any') {
      score += 2;
    }

    const c = state.conditions;
    if (c.outdoor) { score += material.uv_resistant ? 3 : -3; }
    if (c.heat) { score += material.heat_resistant ? 3 : -2; }
    if (c.flexible) { score += material.flexible ? 5 : -5; }
    if (c.impact) { score += material.impact_resistant ? 3 : -1; }
    if (c.ams) { score += (materialKey === 'tpu' || materialKey === 'pa-nylon') ? 0 : 2; }

    if (material.enclosure_recommended && !c.enclosure) score -= 4;
    if (material.drying_recommended && !c.drying) score -= 3;

    return score;
  }

  function computeResults() {
    const scored = Object.keys(MATERIALS).map((key) => ({ key, material: MATERIALS[key], score: scoreMaterial(key, MATERIALS[key]) }));
    scored.sort((a, b) => b.score - a.score);
    return scored.filter((s) => s.score > 0).slice(0, MAX_RESULTS);
  }

  // materialKey (finder bucket, ex "pla-matte") -> valoarea reala din custom.filament_material
  const BUCKET_TO_FIELD = {
    'pla': 'PLA', 'pla-matte': 'PLA Matte', 'petg': 'PETG', 'petg-hf': 'PETG HF',
    'abs': 'ABS', 'asa': 'ASA', 'tpu': 'TPU', 'pa-nylon': 'PA / Nylon', 'pc': 'PC',
  };

  function productsForMaterial(materialKey) {
    const fieldValue = BUCKET_TO_FIELD[materialKey];
    return PRODUCTS.filter((p) => p.material === fieldValue);
  }

  function bestProductForMaterial(materialKey) {
    const candidates = productsForMaterial(materialKey);
    if (!candidates.length) return null;
    const withApp = candidates.filter((p) => state.application && (p.recommendedFor || []).includes(state.application));
    const pool = withApp.length ? withApp : candidates;
    const available = pool.filter((p) => p.variants.some((v) => v.available));
    return (available[0] || pool[0]);
  }

  function groupColors(product) {
    const map = new Map();
    product.variants.forEach((v) => {
      const key = v.color || 'Standard';
      if (!map.has(key)) map.set(key, { name: key, packagings: {}, anyAvailable: false });
      const entry = map.get(key);
      const pkgKey = v.packaging || 'Standard';
      entry.packagings[pkgKey] = v;
      if (v.available) entry.anyAvailable = true;
    });
    return Array.from(map.values());
  }

  // ---------- randare ----------
  const body = root.querySelector('[data-finder-body]');
  const progressBar = root.querySelector('[data-finder-progress]');
  const stepLabel = root.querySelector('[data-finder-step-label]');
  const backBtn = root.querySelector('[data-finder-back]');
  const restartBtn = root.querySelector('[data-finder-restart]');
  const continueBtn = root.querySelector('[data-finder-continue]');

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function render() {
    const step = STEPS[state.stepIndex];
    progressBar.style.width = `${((state.stepIndex + 1) / STEPS.length) * 100}%`;
    stepLabel.textContent = `Pasul ${state.stepIndex + 1} din ${STEPS.length}`;
    backBtn.hidden = state.stepIndex === 0;
    restartBtn.hidden = step !== 'final';
    continueBtn.hidden = step !== 'conditions';

    if (step === 'experience') renderExperience();
    else if (step === 'application') renderApplication();
    else if (step === 'conditions') renderConditions();
    else if (step === 'results') renderResults();
    else if (step === 'colors') renderColors();
    else if (step === 'packaging') renderPackaging();
    else if (step === 'final') renderFinal();
  }

  function renderExperience() {
    const options = [
      { key: 'beginner', label: 'Sunt începător' },
      { key: 'some', label: 'Am ceva experiență' },
      { key: 'advanced', label: 'Sunt utilizator avansat' },
      { key: 'any', label: 'Nu contează, vreau materialul potrivit aplicației' },
    ];
    body.innerHTML = `
      <p class="td-finder__question">Cât de multă experiență ai cu printarea 3D?</p>
      <div class="td-finder__options">
        ${options.map((o) => `<button type="button" class="td-finder__option${state.experience === o.key ? ' is-selected' : ''}" data-experience="${o.key}">${o.label}</button>`).join('')}
      </div>`;
    body.querySelectorAll('[data-experience]').forEach((btn) => {
      btn.addEventListener('click', () => { state.experience = btn.dataset.experience; goNext(); });
    });
  }

  function renderApplication() {
    body.innerHTML = `
      <p class="td-finder__question">Ce vrei să printezi?</p>
      <div class="td-finder__options">
        ${APPLICATIONS.map((a) => `<button type="button" class="td-finder__option${state.application === a.slug ? ' is-selected' : ''}" data-application="${a.slug}">${a.label}<span class="td-finder__option-note">${a.note}</span></button>`).join('')}
      </div>`;
    body.querySelectorAll('[data-application]').forEach((btn) => {
      btn.addEventListener('click', () => { state.application = btn.dataset.application; goNext(); });
    });
  }

  function renderConditions() {
    body.innerHTML = `
      <p class="td-finder__question">Câteva detalii despre proiectul tău</p>
      <div class="td-finder__toggles">
        ${CONDITIONS.map((c) => `
          <label class="td-finder__toggle">
            <input type="checkbox" data-condition="${c.key}" ${state.conditions[c.key] ? 'checked' : ''}>
            <span>${c.label}</span>
          </label>`).join('')}
      </div>`;
    body.querySelectorAll('[data-condition]').forEach((input) => {
      input.addEventListener('change', () => { state.conditions[input.dataset.condition] = input.checked; });
    });
  }

  function renderResults() {
    state.results = computeResults();
    if (!state.results.length) {
      body.innerHTML = `<div class="td-finder-note">Nu am găsit o combinație exactă pentru selecția ta. Încearcă să ajustezi răspunsurile de la pasul anterior.</div>`;
      return;
    }
    body.innerHTML = `
      <p class="td-finder__question">Recomandările noastre</p>
      <div class="td-finder-results">
        ${state.results.map((r, i) => {
          const m = r.material;
          return `
          <div class="td-finder-result">
            <p class="td-finder-result__rank">${i + 1}. ${m.display_name}</p>
            ${SHOW_DIFFICULTY ? `<span class="td-finder-result__difficulty">${m.difficulty}</span>` : ''}
            <p class="td-finder-result__desc">${escapeHtml(m.description)}</p>
            <div class="td-finder-result__pros-cons">
              <div><strong>Avantaje</strong><ul>${(m.advantages || []).map((x) => `<li>${escapeHtml(x)}</li>`).join('')}</ul></div>
              ${SHOW_WARNINGS ? `<div><strong>Limitări</strong><ul>${(m.limitations || []).map((x) => `<li>${escapeHtml(x)}</li>`).join('')}</ul></div>` : ''}
            </div>
            <div class="td-finder-result__actions">
              <button type="button" class="td-button td-button--small" data-see-colors="${r.key}">Vezi culorile disponibile</button>
              <button type="button" class="td-button td-button--small td-button--secondary" data-see-products="${r.key}">Vezi produsele</button>
            </div>
          </div>`;
        }).join('')}
      </div>`;
    body.querySelectorAll('[data-see-colors]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const product = bestProductForMaterial(btn.dataset.seeColors);
        if (!product) return;
        state.chosenMaterialKey = btn.dataset.seeColors;
        state.chosenProduct = product;
        goTo('colors');
      });
    });
    body.querySelectorAll('[data-see-products]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const product = bestProductForMaterial(btn.dataset.seeProducts);
        if (product) window.location.href = product.url;
      });
    });
  }

  function renderColors() {
    const product = state.chosenProduct;
    if (!product) { goTo('results'); return; }
    const colors = groupColors(product);
    body.innerHTML = `
      <p class="td-finder__question">Ai ales: ${escapeHtml(product.title)}</p>
      <p class="td-finder__subtitle" style="margin-bottom:14px">Culori disponibile:</p>
      <div class="td-finder-colors">
        ${colors.map((c) => {
          const key = c.name.toLowerCase();
          return `<button type="button" class="td-finder-color${!c.anyAvailable ? ' is-unavailable' : ''}" data-color="${escapeHtml(c.name)}" ${!c.anyAvailable ? 'disabled' : ''}>
            <span class="td-finder-color__dot" data-color-key="${escapeHtml(key)}"></span>
            <span>${escapeHtml(c.name)}</span>
          </button>`;
        }).join('')}
      </div>`;
    applyColorHexes(body);
    body.querySelectorAll('[data-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.chosenColor = colors.find((c) => c.name === btn.dataset.color);
        goTo('packaging');
      });
    });
  }

  function renderPackaging() {
    const color = state.chosenColor;
    if (!color) { goTo('colors'); return; }
    const pkgs = Object.keys(color.packagings);
    if (!pkgs.length) {
      body.innerHTML = `<p class="td-finder__question">Ambalare</p><div class="td-finder-note">Nu am găsit o configurație disponibilă pentru această culoare.</div>`;
      return;
    }
    if (pkgs.length === 1) {
      state.chosenPackaging = pkgs[0];
      const label = pkgs[0] === 'Standard' ? 'Configurație standard' : pkgs[0];
      const note = pkgs[0] === 'Refill' ? 'Această culoare este disponibilă momentan doar ca Refill.' : (pkgs[0] === 'Cu spool' ? 'Această culoare este disponibilă momentan doar cu spool.' : `Pentru această culoare este disponibilă o singură opțiune: ${escapeHtml(label)}.`);
      body.innerHTML = `
        <p class="td-finder__question">Ambalare</p>
        <div class="td-finder__options"><button type="button" class="td-finder__option is-selected" aria-pressed="true">${escapeHtml(label)}</button></div>
        <div class="td-finder-note">${note}</div>
        ${pkgs[0] === 'Refill' ? '<div class="td-finder-note">Varianta Refill necesită o rolă reutilizabilă compatibilă.</div>' : ''}
        <div class="td-finder__nav" style="margin-top:16px"><button type="button" class="td-button" data-pkg-continue>Continuă cu ${escapeHtml(label)}</button></div>`;
      body.querySelector('[data-pkg-continue]').addEventListener('click', () => goTo('final'));
      return;
    }
    body.innerHTML = `
      <p class="td-finder__question">Alege ambalarea</p>
      <div class="td-finder__options">
        ${pkgs.map((p) => `<button type="button" class="td-finder__option" data-packaging="${escapeHtml(p)}">${escapeHtml(p)}</button>`).join('')}
      </div>
      ${pkgs.includes('Refill') ? '<div class="td-finder-note">Varianta Refill necesită o rolă reutilizabilă compatibilă.</div>' : ''}`;
    body.querySelectorAll('[data-packaging]').forEach((btn) => {
      btn.addEventListener('click', () => { state.chosenPackaging = btn.dataset.packaging; goTo('final'); });
    });
  }

  function renderFinal() {
    const product = state.chosenProduct;
    const color = state.chosenColor;
    const pkg = state.chosenPackaging;
    if (!product || !color || !pkg) { goTo('results'); return; }
    const variant = color.packagings[pkg];
    const available = variant && variant.available;
    body.innerHTML = `
      <div class="td-finder-final">
        <p class="td-finder__question" style="margin-bottom:4px">${escapeHtml(product.title)} — ${escapeHtml(color.name)} — ${escapeHtml(pkg)}</p>
        <p class="td-finder-final__status ${available ? 'is-available' : 'is-unavailable'}">${available ? 'În stoc' : 'Indisponibil momentan'}</p>
        ${variant ? `<p class="td-finder-final__price">${(variant.price / 100).toFixed(2)} lei</p>` : ''}
        <div class="td-finder-result__actions" style="justify-content:center">
          ${available ? `<form method="post" action="/cart/add"><input type="hidden" name="id" value="${escapeHtml(variant.id)}"><input type="hidden" name="quantity" value="1"><button type="submit" class="td-button">Adaugă în coș</button></form>` : ''}
          <a class="td-button" href="${product.url}${variant ? '?variant=' + variant.id : ''}">Vezi produsul</a>
          <button type="button" class="td-button td-button--secondary" data-finder-restart-inline>Reia selecția</button>
        </div>
      </div>`;
    body.querySelector('[data-finder-restart-inline]').addEventListener('click', () => { resetState(); render(); });
  }

  function applyColorHexes(scope) {
    if (!window.TD_COLOR_MAP) return;
    scope.querySelectorAll('[data-color-key]').forEach((el) => {
      const hex = window.TD_COLOR_MAP.flat[el.getAttribute('data-color-key')];
      if (hex) el.style.setProperty('--swatch-color', hex);
    });
  }

  function goTo(stepName) {
    const idx = STEPS.indexOf(stepName);
    if (idx >= 0) state.stepIndex = idx;
    render();
  }
  function goNext() {
    if (state.stepIndex < STEPS.length - 1) state.stepIndex += 1;
    render();
  }
  function goBack() {
    if (state.stepIndex > 0) state.stepIndex -= 1;
    render();
  }

  backBtn.addEventListener('click', goBack);
  continueBtn.addEventListener('click', goNext);
  restartBtn.addEventListener('click', () => { resetState(); render(); });

  let releaseFocus = null;
  function open() {
    root.hidden = false;
    window.TDOverlay.lock();
    releaseFocus = window.TDOverlay.trapFocus(root);
    resetState();
    render();
  }
  function close() {
    root.hidden = true;
    window.TDOverlay.unlock();
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
  }

  document.querySelectorAll('[data-finder-open]').forEach((el) => el.addEventListener('click', open));
  root.querySelectorAll('[data-finder-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });
})();
